export default __webpack_public_path__ + "static/media/023-passport.e4c590e6.svg";